import common from './en/common';
import errors from './en/errors';
import home from './en/home';
import center from './en/center';
import custom from './en/custom';
import live from './en/live';
import search from './en/full-text-search';
import train from './en/train';

export default {
    center: {
        ...center
    },
    home: {
        ...home
    },
    search: {
        ...search
    },
    lang: {
        ...common,
        ...errors,
        ...train
    },
    custom: {
        ...custom
    },
    live: {
        ...live
    }
};
